import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@pinup-teams/common';

import { SupportFormWrapperComponent } from './support-form-wrapper.component';
import { SupportCategories } from '../../models';

@Injectable()
export class SupportFormDialog {
  #dialog = inject(DialogService);

  open(category: SupportCategories): DialogRef {
    return this.#dialog.open(SupportFormWrapperComponent, { category });
  }
}
